export default __webpack_public_path__ + "media/zurb/img/legacy/spur/grids-96e6735eef39ea88febd1fa5da1d0317.jpg";